import type { Movie } from "@/mocks/movies";
import type { MovieFilters } from "@/components/feature/MovieFilterBar";
import type { SortKey } from "@/components/feature/SortTabs";

export function filterMovies(list: Movie[], filters: MovieFilters): Movie[] {
  return list.filter((movie) => {
    if (filters.region !== "全部" && movie.region !== filters.region) return false;
    if (filters.year !== "全部" && String(movie.year) !== filters.year) return false;
    if (filters.version !== "全部" && movie.version !== filters.version) return false;
    if (filters.genre !== "全部" && !movie.genres.includes(filters.genre)) return false;
    return true;
  });
}

export function sortMovies(list: Movie[], sort: SortKey): Movie[] {
  const copy = [...list];
  if (sort === "views") {
    return copy.sort((a, b) => b.views - a.views);
  }
  if (sort === "rating") {
    return copy.sort((a, b) => b.rating - a.rating);
  }
  return copy.sort((a, b) => b.year - a.year || b.rating - a.rating);
}

export function searchMovies(list: Movie[], keyword: string): Movie[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return list;
  return list.filter((movie) => {
    const haystack = [
      movie.title,
      movie.director,
      movie.region,
      movie.version,
      movie.subtitle,
      movie.description,
      ...movie.genres,
      ...movie.actors,
      ...movie.tags,
      String(movie.year),
    ]
      .join(" ")
      .toLowerCase();
    return haystack.includes(q);
  });
}

export function paginate<T>(list: T[], page: number, pageSize: number): T[] {
  const start = (page - 1) * pageSize;
  return list.slice(start, start + pageSize);
}

export function getRelated(movie: Movie, list: Movie[], limit = 8): Movie[] {
  return list
    .filter((item) => item.id !== movie.id)
    .map((item) => {
      let score = 0;
      const sharedGenres = item.genres.filter((g) => movie.genres.includes(g)).length;
      score += sharedGenres * 3;
      if (item.year === movie.year) score += 2;
      if (item.region === movie.region) score += 1;
      if (Math.abs(item.year - movie.year) <= 1) score += 1;
      return { item, score };
    })
    .sort((a, b) => b.score - a.score || b.item.rating - a.item.rating)
    .slice(0, limit)
    .map((entry) => entry.item);
}